import { table } from './_table';

export const users = {
  namespaced: true,
  modules: {
    table
  }
};
